/**
 * The canonical interest planned activity kind vocabulary. This `as const` tuple is the single
 * source of truth so the zod mirror in `src/context/` can build `z.enum(...)` from it and cannot
 * drift from the pure engine types.
 */
export const INTEREST_PLANNED_ACTIVITY_KINDS = ['task', 'testDrive'] as const;
